<template>
  <v-row dense>
    <v-col cols="12" :style="{'margin-top': '15px'}">
      <span class="subtitle-2">Recipients Email</span>
      <v-btn icon @click="removeAll()">
        <v-icon color="red">mdi-delete</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="12">
      <template v-for="(user, index) in list">
        <v-chip :key="index" class="ma-2" color="primary" outlined>
          {{user.email}}
          <v-btn icon right @click="removeEmail(user)" color="primary">
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </v-chip>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ReceiversList',
  props: ['list'],
  methods: {
    removeEmail (user) {
      this.$emit('removeEmail', {user: user})
    },
    removeAll () {
      this.$emit('removeAll')
    }
  }
}
</script>